import WindowFloat from '@/frontend/components/qecomps/WindowFloat'
import Router from 'next/router'
import Items from './Items'

import Component, { PageEl } from '@/frontend/components/qecomps/Component'
export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {
  var Item = Items()[z.lang.code][props.item.guaranteemode];

  return <WindowFloat title={z.lang.gauranteeconds} onclose={() => { props.onclose?.() }}>
    
    <Item days={props.item.guaranteedays} />

    {props.isservice ? <f-cc>
      <b-200 class={z.styles.btnaccept} style={{ width: "90%"}}
        onClick={() => { Router.push('/en/newchat?dep=guarantee') }}>{z.lang.sendguarequest}</b-200>
    </f-cc> : null}
    <br-x />
  </WindowFloat>
}